export function resolveAnnouncementRows(announcements) {
    return (announcements ?? []).map((announcement) => ({
        id: announcement.documentId,
        name: announcement.name,
        notes: announcement.notes,
        isPublished: Boolean(announcement.isPublished),
        isContentLocked: Boolean(announcement.isContentLocked),
        frequency: announcement.frequency ?? 'oncePerUser',
        startAt: announcement.startAt ?? null,
        endAt: announcement.endAt ?? null,
        totalViewings: Number(announcement.totalViewings ?? 0),
        totalViewingDuration: Number(announcement.totalViewingDuration ?? 0),
        totalConversions: Number(announcement.totalConversions ?? 0),
        totalUniqueConversions: Number(announcement.totalUniqueConversions ?? 0),
    }))
}
